export const DEPENDENCY_FIELDS = {
    "lotteryKey": "lotteryKey"
};

export const REPORT_DEPENDENCIES = {
    "Income Group Master Report": [DEPENDENCY_FIELDS.lotteryKey],
    "Scheme Master Report": [DEPENDENCY_FIELDS.lotteryKey],
    "Category Master Report": [DEPENDENCY_FIELDS.lotteryKey],
    "Tenement Master Report": [DEPENDENCY_FIELDS.lotteryKey],
    "Scheme Category Master Report": [DEPENDENCY_FIELDS.lotteryKey],
    "Application Summary Report": [DEPENDENCY_FIELDS.lotteryKey],
    "Moderation Report": [],
    "EMD/ Fee Collection Report": [DEPENDENCY_FIELDS.lotteryKey],
    "Registration Summary Report": [],
    "Category Wise Application Summary Report": [DEPENDENCY_FIELDS.lotteryKey],
    "Scheme wise Application Summary Report": [DEPENDENCY_FIELDS.lotteryKey],
    "Domicile Pending Day Wise Report": [],
    "Income Certificate Pending Day Wise Report": [],
    "Caste Certificate Pending Day Wise Report": [],
    "Caste Validity Certificate Pending Day Wise Report": [],
    "AR-JR Certificate Pending Day Wise Report": [],
    "Refund Process Report": [DEPENDENCY_FIELDS.lotteryKey]
}
